export const LABELS = {
  APPLICATION_TARGET_SERVICE: "申請対象サービス",
  APPLICATION_FILE: "申請ファイル",
  FILE_PLACEHOLDER: "アップロード対象ファイル",
  FOR_CORPORATION: "法人提出用",
  FOR_STORE: "店舗提出用",
  CONTRACT_ROUTE: "契約ルート",
  NO: "No",
  ERROR_DETAIL: "エラー内容",
  ERROR_TITLE_FOR_CORPORATION: "法人提出用エラー内容",
  ERROR_TITLE_FOR_STORE: "店舗提出用エラー内容",
  ERROR_TEXT_LABEL: "まだファイルはアップロードされていません。",
  MAINTENANCE_LABEL: "メンテナンス",
  CANCELLATION: "解約",
};
export const CONFIGS = {
  FILE: "file",
  FILE_EXTENSION: ".xlsx",
  UPLOAD_TYPE: "uploadType",
  CORPORATION: "法人用",
  STORE: "店舗用",
  COMPANY_CODE: "comprehensiveCompanyCode",
  MAINTENANCE_FLG: "maintenanceFlg",
  TARGET: "target",
};
export const CONTENTS = {
  APPLICATION_CONFIRM_CORPORATE: "\r\n・法人提出用\r\n　　ファイル名：{0}",
  APPLICATION_CONFIRM_STORE: "\r\n・店舗提出用\r\n　　ファイル名：{0}",
};
export const ARROW_STYLE = {
  fontFamily:
    "'游ゴシック体', 'YuGothic', '游ゴシック', 'Yu Gothic', sans-serif",
};
export const APPLICATION_NOTICE = `
■加盟店情報申請書式について\r\n
　　以下2種類の申請様式で申請願います。\r\n
　　　　①法人提出用\r\n
　　　　　　料率を払い出す加盟店に対する企業・屋号（商業施設含む）の情報に対する申請\r\n
　　　　②店舗提出用\r\n
　　　　　　屋号・商業施設に紐づく店舗情報やテナント情報（テナントを運営する企業情報含む）に対する申請\r\n
■申請時の注意事項\r\n
　　「法人提出用」と「店舗提出用」を同時に申請するときは、\r\n
　　申請様式間を紐づける情報を「加盟店管理番号」欄に記載いただいたうえ、申請いただくようお願いします。\r\n
　　「加盟店管理番号」の記載が難しい場合は、「法人提出用」の様式のみ申請いただき、\r\n
　　後日ドコモ側で払い出したサイトIDを用いて、「店舗提出用」の申請様式を申請ください。
`;
export const CORPORATE_APPLICATION_CHANGE_NOTICE = `\r\n
　　＜法人提出用で変更申請をされる場合の注意事項＞\r\n
　　法人提出用で変更申請される場合、サイトIDに対する加盟店名や企業名が変更になります。\r\n
　　（例：商業施設名、フランチャイズの加盟店名、包括加盟店自身の加盟店名　など）\r\n
　　店舗やテナント情報の変更の場合は店舗提出用のみになりますので、ご確認の上申請をお願いします。
`;
export const CORPORATE_APPLICATION_CHANGE_MODAL_NOTICE_TITLE =
  "法人提出用のファイルで変更申請を行う場合";
export const CORPORATE_APPLICATION_CHANGE_MODAL_NOTICE = `\r\n
　法人提出用で変更申請される場合、サイトIDに対する加盟店名や企業名が変更になります。\r\n
　　（例：商業施設名、フランチャイズの加盟店名、包括加盟店自身の加盟店名　など）\r\n
　店舗やテナント情報の変更の場合は店舗提出用のみになりますので、ご確認の上申請をお願いします。\r\n
`;

/** チェック対象：包括店舗 */
export const CHECK_TARGET_MERCHANT_STORE = "1";
export const CANCEL_NOTICE = "サイトIDの解約申請が含まれています。";
export const CANCEL_NOTICE_CONTENT =
  "\r\n　こちらのサイトIDに紐付く店舗が営業中の場合は、自動で閉店処理を実施します\r\n";

export const UPDATE_DIFFERENCIAL_INFO = {
  SHEET_NAME: "提出用",
  ROW_NO: 19,
  COL_NO: 2,
};
